var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.1796,
    height: 22.7573,
    fill: "#858585"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6752 7.08201H15.6817M8.83025 4.14845H15.3493C17.1494 4.14845 18.6088 5.60778 18.6088 7.40796V13.927C18.6088 15.7271 17.1494 17.1865 15.3493 17.1865H8.83025C7.03007 17.1865 5.57074 15.7271 5.57074 13.927V7.40796C5.57074 5.60778 7.03007 4.14845 8.83025 4.14845ZM14.6974 10.2568C14.7778 10.7993 14.6851 11.3534 14.4325 11.8402C14.1799 12.3271 13.7802 12.7219 13.2903 12.9685C12.8004 13.2151 12.2452 13.3009 11.7037 13.2137C11.1622 13.1266 10.6619 12.8709 10.2741 12.4831C9.88627 12.0953 9.63061 11.595 9.54347 11.0535C9.45633 10.512 9.54216 9.95682 9.78875 9.46691C10.0353 8.97699 10.4301 8.5773 10.917 8.32469C11.4038 8.07208 11.9579 7.97941 12.5004 8.05986C13.0539 8.14193 13.5662 8.3998 13.9618 8.7954C14.3574 9.19101 14.6153 9.70335 14.6974 10.2568Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6456,
    height: 15.6456,
    fill: "white",
    transform: "translate(4.26694 2.84465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.389b184f8a0de14a102e9aad74df0ced.svg";
export { ForwardRef as ReactComponent };